import React, {PureComponent} from 'react';
import Cookie from 'js-cookie';
import $ from 'jquery';

import 'vendor/redactor/2/redactor.css';
import 'vendor/redactor/2/redactor.min';
import 'vendor/redactor/2/ru';
import 'vendor/jquery-wa/editor2';

import styles from './RedactorTextarea.less';

// todo disable

export default class RedactorTextarea extends PureComponent {
	componentDidMount() {
		const htmlHandler = (html) => {
			html = html.replace(/{[a-z$][^}]*}/gi, (match, offset, full) => {
				const i = full.indexOf('</script', offset + match.length);
				const j = full.indexOf('<script', offset + match.length);

				if (i === -1 || (j !== -1 && j < i)) {
					match = match.replace(/&gt;/g, '>');
					match = match.replace(/&lt;/g, '<');
					match = match.replace(/&amp;/g, '&');
					match = match.replace(/&quot;/g, '"');
				}

				return match;
			});

			return html;
		};

		$(this.wysiwyg).waEditor({
			lang: 'ru',
			toolbarFixed: false,
			minHeight: 150,
			focus: false,
			uploadFields: {
				_csrf: Cookie.get('_csrf')
			},
			callbacks: {
				change: (val) => {
					const {disabled, onChange} = this.props;
					if (disabled) {
						return;
					}

					const e = $.Event('change', {target: this.wysiwyg});
					$(this.wysiwyg).waEditor('sync');
					$(this.wysiwyg).trigger('change');

					if (onChange) {
						onChange(e);
					}
				},
				sync: (html) => {
					this.wysiwyg.value = htmlHandler(html);
				}
			}
		});
	}

	componentWillUpdate(nextProps, nextState, nextContext) {
		const $textarea = $(this.wysiwyg, nextProps);
		const {value} = nextProps;

		if ($textarea.waEditor('get') !== value) {
			this.is_changed = true;
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const $textarea = $(this.wysiwyg);
		const {disabled} = this.props;

		if (disabled) {
			// $textarea.redactor('insertion.insertHtml', '<p>azaza!</p>')

			try {
				// $textarea.redactor('disable', true);
			}
			catch (e) {
				console.warn(e);
			}
		}

		if (this.is_changed && !disabled) {
			$textarea.waEditor();
		}

		this.is_changed = false;
	}

	render() {
		const {className, textareaRef, disabled, onChange, ...props} = this.props;

		const classes = [];
		classes.push(styles['redactor-textarea']);
		classes.push('wa-editor-core-wrapper s-editor-core-wrapper');

		if (className) {
			classes.push(className);
		}

		if (disabled) {
			classes.push(styles['redactor-textarea_disabled']);
		}

		const _onChange = disabled
			? e => {e.preventDefault();e.stopPropagation();return false}
			: onChange;

		return (
			<div className={classes.join(' ')}>
				<ul className='wa-editor-wysiwyg-html-toggle s-wysiwyg-html-toggle'>
					<li className='selected'><a className='wysiwyg' href='#'>Визуальный редактор</a></li>
					<li><a className='html' href='#'>HTML</a></li>
				</ul>
				<div>
					<textarea className={styles['redactor-textarea__control']} onChange={_onChange} {...props}
						ref={(input) => {
							this.wysiwyg = input;

							if (typeof textareaRef === 'function') {
								textareaRef(input);
							}
						}} />
				</div>
			</div>
		);
	}
}
